import RedirectToNewQuestionsRouter from './RedirectToNewQuestionsRouter.component';

export default RedirectToNewQuestionsRouter;
